import { ADD_TO_CART, FETCH_USER, KEEP_USER, LOGIN_USER, REMOVE_FROM_CART } from '../actions/types';
const initialState = { key: '', name: '', userId: '', isAuth: false, cartItems: [] }
export default function (state, action) {
    state = state || initialState;
    switch (action.type) {
        case FETCH_USER:
        case LOGIN_USER:
        case KEEP_USER:
            return action.payload || initialState;
        case ADD_TO_CART: {
            const item = action.payload;
            const exists = state.cartItems && state.cartItems.find(p => p.id === item.id);

            if (exists) {
                return {
                    ...state,
                    cartItems: state.cartItems.map(p =>
                        p.id === item.id ? { ...p, quantity: (p.quantity || 1) + 1 } : p
                    )
                };
            }
            else {
                return {
                    ...state,
                    cartItems: [...(state.cartItems || []), { ...item, quantity: 1 }]
                };
            }
        }
        case REMOVE_FROM_CART:
            return {
                ...state,
                cartItems: state.cartItems.filter(p => p.id !== action.payload)
            };

        default:
            return state;
    }
}